import { useMutation, useQueryClient } from "@tanstack/react-query";
import { appointmentService } from "..";
import { PlaceAnAppointmentPayload } from "../type";

function useCreateAppointment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (command: PlaceAnAppointmentPayload) => {
      return appointmentService.createAppointment(command);
    },
    // The calendar and today's list read these; show the new booking without a page reload.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["getDailyAppointment"] }),
  });
}

export default useCreateAppointment;
